import { render, staticRenderFns } from "./OrderCancel.vue?vue&type=template&id=350a6a72&scoped=true&"
import script from "./OrderCancel.vue?vue&type=script&lang=js&"
export * from "./OrderCancel.vue?vue&type=script&lang=js&"
import style0 from "../../less/order.less?vue&type=style&index=0&id=350a6a72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a6a72",
  null
  
)

export default component.exports